export default [
    {
        name: 'Despesas',
        url: '/despesasgerais/financeiro/despesas',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        },
        regras: 'DESP-GERAIS-FINAN-00'
    },
    {
        name: 'Pagamentos',
        url: '/despesasgerais/financeiro/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        },
        regras: 'DESP-GERAIS-FINAN-PAG-00'
    },
]